export default "__VITE_ASSET__CTGiXUuU__"